/**
 * target を上の sticky ヘッダーと下に重なる要素を除いた可視領域の縦中央に寄せる scrollTop を返す（スクロール可能範囲で clamp）。
 * rect はいずれも getBoundingClientRect (viewport 基準) の値を渡す。
 */
export function computeScrollTopToCenterElement({
  containerScrollTop,
  containerTop,
  containerClientHeight,
  containerScrollHeight,
  stickyHeaderHeight,
  bottomOverlayHeight,
  targetTop,
  targetHeight,
}: {
  containerScrollTop: number;
  containerTop: number;
  containerClientHeight: number;
  containerScrollHeight: number;
  stickyHeaderHeight: number;
  /** コンテナ下端に重ねて描画される要素の高さ。clientHeight を減らさないので別途差し引く */
  bottomOverlayHeight: number;
  targetTop: number;
  targetHeight: number;
}): number {
  const visibleCenter =
    containerTop +
    stickyHeaderHeight +
    (containerClientHeight - stickyHeaderHeight - bottomOverlayHeight) / 2;
  const targetCenter = targetTop + targetHeight / 2;
  const scrollTop = containerScrollTop + (targetCenter - visibleCenter);
  const maxScrollTop = Math.max(
    0,
    containerScrollHeight - containerClientHeight,
  );
  return Math.min(Math.max(scrollTop, 0), maxScrollTop);
}
